import type { IntegrationItem } from '../types'

export default {
  nav: {
    features: "Возможности",
    pricing: "Цена",
    integrations: "Интеграции",
    how: "Как это работает",
    cta: "Связаться",
    download: "Скачать",
    apps: "Приложения",
    menu: "Меню",
    primary_nav: "Основная навигация",
  },
  hero: {
    title_1: "Одно меню, один склад —",
    title_2: "всё заведение",
    title_3: "в одной системе",
    subtitle:
      "Касса, своя доставка, QR-меню, приложение официанта, экраны и склад работают на одном меню. Измените цену один раз — она изменится везде. Продали последнюю порцию — она исчезнет с витрины в ту же секунду.",
    cta_primary: "Связаться",
    cta_secondary: "Как это работает",
    trust: "Первый месяц бесплатно, полный набор · Настройку делает наша команда",
    stat_venues_val: "20+",
    stat_venues: "заведений",
    stat_country: "Узбекистан",
    stat_payments: "Click / Payme / Rahmat",
    stat_trial_val: "1 месяц",
    stat_trial: "бесплатно",
    dashboard: {
      url: "samly.uz/dashboard",
      home: "Главная",
      orders: "Заказы",
      menu: "Меню",
      kitchen: "Кухня",
      analytics: "Аналитика",
      staff: "Сотрудники",
      revenue_label: "Выручка сегодня",
      currency: "сум",
      orders_count: "Заказы",
      avg_check: "Средний чек",
      avg_time: "Среднее время",
      avg_time_val: "14 мин",
      paid: "Оплачен",
      waiting: "Ожидает",
      order: "Заказ",
      table: "Стол",
    },
  },
  logos: {
    title: "Работает в заведениях любого формата",
    formats: {
      restaurants: "Рестораны",
      cafes: "Кофейни",
      oshkhona: "Ошхона",
      fastfood: "Фастфуд",
      chains: "Сети",
    },
  },
  painpoints: {
    title: "Три системы — и все три считают по-разному",
    subtitle:
      "Касса, склад в Excel и витрина у агрегатора не знают друг о друге. Вы узнаёте об этом от гостя.",
    before_label: "Без Samly",
    after_label: "С Samly",
    before: [
      "Цену подняли в кассе — на витрине доставки осталась старая",
      "Плов закончился, а заказы на него продолжают приходить",
      "Склад в Excel, касса отдельно, доставка у агрегатора",
      "Официант обещает гостю блюдо, которого нет на кухне",
      "Чтобы собрать отчёт, нужно сводить три выгрузки вручную",
    ],
    after: [
      "Цену меняете один раз — она меняется на всех точках продаж",
      "Продали последнюю порцию — блюдо исчезло с витрины",
      "Склад, касса и доставка считают один и тот же остаток",
      "Стоп-лист виден официанту, кухне и гостю одновременно",
      "Один отчёт по всему заведению — сводить нечего",
    ],
  },
  onemenu: {
    tag: "Как это работает",
    title: "Одно меню. Один склад. Шесть точек продаж.",
    subtitle: "Вы ведёте меню и остатки в одном месте. Остальное Samly держит в курсе сам.",
    hub_title: "Одно меню",
    hub_sub: "один склад",
    surfaces: {
      pos: "Касса",
      storefront: "Своя доставка",
      qr: "QR-меню",
      waiter: "Официант",
      screens: "Экраны",
      warehouse: "Склад",
    },
    moments: [
      {
        title: "Измените цену один раз",
        desc: "Новая цена сразу на кассе, в QR-меню, на витрине доставки, у официанта и на экранах. Дублировать ничего не нужно.",
      },
      {
        title: "Продайте последнюю порцию",
        desc: "Блюдо уходит в стоп-лист в ту же секунду: исчезает с витрины, гость его больше не увидит, официант не сможет его пробить.",
      },
      {
        title: "Склад считает ингредиенты",
        desc: "У каждого блюда есть технологическая карта. Продали плов — со склада списались рис, масло и мясо. Остаток настоящий, а не «примерно».",
      },
    ],
  },
  stats: {
    items: [
      { val: "20+", label: "заведений", sub: "работают на Samly" },
      { val: "1 месяц", label: "бесплатно", sub: "полный набор, без карты" },
      { val: "9", label: "компонентов", sub: "платите только за свои" },
      { val: "−30%", label: "при оплате за год", sub: "минимальный срок — 3 месяца" },
    ],
  },
  features: {
    title: "Шесть точек продаж, одно меню под ними",
    subtitle: "Включайте то, что нужно вашему заведению. Остальное просто не покупаете.",
    tabs: {
      pos: "Касса",
      storefront: "Своя доставка",
      qr: "QR-меню",
      waiter: "Официант",
      kitchen: "Кухня",
      warehouse: "Склад",
    },
    mock: {
      hall: "Зал · 12 столов",
      st_free: "свободен",
      st_paid: "оплачен",
      st_waiting: "ждёт",
      st_ordered: "заказ",
      accept_payment: "Принять оплату",
      pin: "PIN",
      my_tables: "Мои столы",
      online: "онлайн",
      guests: "гостей",
      positions: "позиций",
      cooking: "Готовится",
      ready: "Готово",
      accepted: "Принят",
      kitchen_station: "Кухня · горячий цех",
      delivery: "Доставка",
      storefront_head: "Ваша витрина · Telegram",
      add_to_cart: "В корзину",
      sold_out: "Нет в наличии",
      checkout: "Оформить заказ",
      warehouse_head: "Списание по рецепту",
      warehouse_sold: "Продан 1 плов",
      warehouse_left: "осталось",
      stop_list: "Стоп-лист",
      table: "Стол",
      total: "Итого",
      currency: "сум",
      your_order: "Ваш заказ",
      pay_click: "Оплатить Click",
      pay_payme: "Оплатить Payme",
      dishes: {
        plov: "Плов",
        lagman: "Лагман",
        tea: "Чай",
        shashlik: "Шашлык",
        manti: "Манты",
        soup: "Суп",
        salad: "Салат",
      },
      units: { g: "г", kg: "кг", ml: "мл", l: "л" },
      ingredients: {
        rice: "Рис",
        oil: "Масло",
        meat: "Говядина",
        carrot: "Морковь",
      },
    },
    pos: {
      title: "Касса, которая знает реальный остаток",
      points: [
        "Наличные, карта и QR в одном окне",
        "Возвраты, скидки и удаления — только по PIN менеджера",
        "Смены и расхождения по кассе под контролем",
        "E-Kassa (ОФД) — фискализация по правилам Узбекистана",
        "Работает без интернета, синхронизируется после",
      ],
    },
    storefront: {
      title: "Своя витрина, а не полка у агрегатора",
      points: [
        "Telegram Mini App, сайт и мобильное приложение",
        "Свой домен — гость видит ваш бренд, а не чужой",
        "Оплата через Click, Payme и Rahmat",
        "Заказ приходит сразу в кассу и на кухню",
        "Комиссию агрегатора за свои заказы вы не платите",
      ],
    },
    qr: {
      title: "Гость заказывает со своего телефона",
      points: [
        "QR на столе — меню открывается в браузере, без приложения",
        "Общая корзина на весь стол",
        "Оплата через Click, Payme и Rahmat",
        "То же меню и те же остатки, что в кассе",
        "Гость видит статус заказа и не переспрашивает",
      ],
    },
    waiter: {
      title: "Официант не продаст то, чего нет",
      points: [
        "Планшет или любой Android-телефон",
        "Стоп-лист обновляется в реальном времени",
        "Комментарии к блюдам: без лука, поострее",
        "Дозаказ к столу — заказ не нужно пересобирать",
        "Push, когда блюдо готово",
      ],
    },
    kitchen: {
      title: "Повар видит заказ, а не бумажку",
      points: [
        "Автоматическое разделение по цехам: горячий, холодный, бар",
        "Таймер на каждое блюдо из технологической карты",
        "Статусы «готовится» → «готово» → официанту",
        "Аналитика времени приготовления по каждому повару",
        "Входит в подписку — отдельно платить не нужно",
      ],
    },
    warehouse: {
      title: "Склад считает ингредиенты, а не порции",
      points: [
        "Технологическая карта на каждое блюдо",
        "Продали плов — списались рис, масло и мясо",
        "Себестоимость и маржа по каждой позиции",
        "Стоп-лист формируется сам, когда ингредиент кончился",
        "Несколько складов, если кухонь больше одной",
      ],
    },
  },
  integrations: {
    title: "Работает с тем, что вы уже используете",
    subtitle: "Оплата, доставка, оборудование и фискализация — из коробки.",
    soon: "в планах",
    groups: {
      payment: {
        title: "Оплата",
        items: [
          { name: "Click", desc: "QR и онлайн-оплата" },
          { name: "Payme", desc: "Онлайн-оплата" },
          { name: "Rahmat", desc: "Онлайн-оплата" },
          { name: "Uzum Pay", desc: "Планируем подключить", soon: true },
        ] as IntegrationItem[],
      },
      delivery: {
        title: "Доставка",
        items: [
          { name: "Своя витрина", desc: "Telegram, сайт, приложение" },
          { name: "Yandex Eats", desc: "Заказы приходят автоматически" },
          { name: "Uzum Tezkor", desc: "Планируем подключить", soon: true },
        ] as IntegrationItem[],
      },
      equipment: {
        title: "Оборудование",
        items: [
          { name: "ESC/POS", desc: "Любой чековый принтер" },
          { name: "StarPRNT", desc: "Автопечать чеков" },
          { name: "Smart TV / Fire Stick", desc: "Для экранов меню" },
        ] as IntegrationItem[],
      },
      local: {
        title: "Узбекистан",
        items: [
          { name: "E-Kassa (ОФД)", desc: "Фискализация и отчётность" },
          { name: "Android / iOS", desc: "Любые устройства" },
          { name: "Open API", desc: "Свои интеграции, входит в подписку" },
        ] as IntegrationItem[],
      },
    },
  },
  dashboardPreview: {
    owner: {
      badge: "Владелец",
      title: "Все филиалы на одном экране",
      features: {
        revenue: "Выручка по всем филиалам в реальном времени",
        alert: "Уведомление, если смена закрыта с расхождением",
        reports: "Отчёт по каждой смене — автоматически",
      },
      cta: "Посмотреть возможности",
      mockup: {
        title: "3 филиала · сегодня",
        live: "live",
        revenue: "сум",
        week: "к прошлой неделе",
        branches: {
          chilanzar: "Чиланзар",
          yunusabad: "Юнусабад",
          samarkand: "Самарканд",
        },
      },
    },
    qr: {
      badge: "QR-меню",
      title: "Гость заказывает и платит сам",
      features: {
        no_app: "Без приложения — достаточно навести камеру",
        payments: "Click, Payme и Rahmat — меньше чем за минуту",
        cart: "Общая корзина на весь стол",
      },
      cta: "Как работает QR-меню",
      slides: {
        menu: "Меню и наличие",
        dish: "Карточка блюда",
        cart: "Корзина и оплата",
      },
    },
    monitors: {
      badge: "Экраны",
      title: "Экраны показывают то же меню",
      features: {
        playlist: "Видео и фото по расписанию",
        offline: "Работают без интернета — с USB-накопителя",
        update: "Контент меняется с телефона за секунды",
      },
      cta: "Подробнее об экранах",
      mockup: {
        menu_day: "Меню дня",
        lunch: "Бизнес-ланч",
        action: "АКЦИЯ −15%",
        items: {
          lagman: "Лагман",
          plov: "Плов",
          shashlik: "Шашлык",
          manti: "Манты",
        },
      },
    },
  },
  components: {
    title: "Платите только за то, что используете",
    subtitle: "Тарифов нет. Цена — сумма компонентов. Всё остальное входит в подписку.",
    paid_title: "Компоненты подписки",
    paid_note:
      "Цена за месяц. Своя доставка, приложение официанта, QR-меню и Yandex Eats покупаются на каждый филиал.",
    free_title: "Входит в подписку — без доплат",
    free_badge: "Входит",
    per_month: "/мес",
    per_branch: "на филиал",
    min_one: "минимум 1",
    cta: "Собрать свой набор",
    items: {
      branches: { name: "Филиалы", desc: "Каждая точка со своим залом и складом" },
      employees: { name: "Сотрудники", desc: "Учётная запись на человека, включая владельца" },
      pos_devices: { name: "POS-устройства", desc: "Касса на моноблоке, планшете или телефоне" },
      online_orders: {
        name: "Своя доставка",
        desc: "Telegram Mini App, сайт и приложение на своём домене",
      },
      waiter_app: {
        name: "Приложение официанта",
        desc: "Заказы с планшета или телефона, живой стоп-лист",
      },
      qr_menu: { name: "QR-меню", desc: "Меню и оплата с телефона гостя" },
      yandex: { name: "Yandex Eats", desc: "Заказы из Yandex Eats приходят автоматически" },
      monitors: { name: "Экраны меню", desc: "Цифровое меню и промо на любом Smart TV" },
      warehouses: { name: "Склады", desc: "Учёт ингредиентов по технологическим картам" },
    },
    free_items: {
      kds: { name: "Кухня (KDS)", desc: "Экран повара с таймерами и очередью" },
      manager_app: { name: "Приложение менеджера", desc: "План зала и сотрудники с телефона" },
      loyalty_crm: { name: "Лояльность и CRM", desc: "База гостей и программа лояльности" },
      ai_analytics: { name: "AI-аналитика", desc: "Прогнозы и подсказки по продажам" },
      kiosk: { name: "Киоск самообслуживания", desc: "Гость оформляет заказ сам" },
      open_api: { name: "Open API", desc: "Интеграции с вашими системами" },
      stop_list: {
        name: "Стоп-лист в реальном времени",
        desc: "Кончилось — сразу скрыто во всех точках",
      },
      cash_shift: { name: "Смены и Z-отчёты", desc: "Открытие, закрытие, расхождения" },
      order_management: { name: "Управление заказами", desc: "Создание, изменение, отмена" },
      basic_analytics: { name: "Аналитика", desc: "Выручка, средний чек, топ блюд" },
      order_status: { name: "Экран статуса заказа", desc: "Для гостей в зале" },
      e_kassa: { name: "E-Kassa (ОФД)", desc: "Фискализация по правилам Узбекистана" },
      pin_protection: { name: "PIN на возвраты", desc: "Возврат только с подтверждения менеджера" },
      floor_plan: { name: "План зала и столы", desc: "Визуальная схема зала" },
      owner_push: { name: "Push владельцу", desc: "Уведомления о нарушениях" },
      qr_generator: { name: "Генератор QR-кодов", desc: "Для столов — печать и экспорт" },
      payment_types: { name: "Типы оплаты", desc: "Наличные, карта, QR" },
      receipt_printer: { name: "Печать чеков", desc: "ESC/POS, StarPRNT — любое оборудование" },
    },
  },
  pricing: {
    tag: "Цена",
    title: "Тарифов нет. Соберите свой набор.",
    subtitle: "Цена — сумма компонентов, привязанная к БРВ. Минимальный срок — 3 месяца.",
    from_label: "от",
    per_month: "сум/мес",
    from_note: "за минимальный набор при оплате за 12 месяцев",
    term_title: "Срок оплаты",
    term_note: "минимум 3 месяца",
    build_title: "Соберите набор",
    reset: "Сбросить",
    col_component: "Компонент",
    col_unit: "Цена за единицу",
    col_qty: "Кол-во",
    col_sum: "Сумма/мес",
    brv_label: "БРВ, сум",
    brv_unit: "БРВ",
    brv_note:
      "1 БРВ = {{value}} сум. Цены привязаны к БРВ: при его изменении сумма в сумах пересчитывается автоматически.",
    matrix_title: "Ваш набор по срокам",
    col_term: "Срок",
    col_discount: "Скидка",
    col_per_month: "В месяц",
    col_total: "Итого",
    receipt_title: "СЧЁТ",
    receipt_empty: "Набор пуст",
    receipt_base: "Цена в месяц без скидки",
    receipt_full: "За {{months}} мес без скидки",
    receipt_discount: "Скидка за срок",
    receipt_total_sub: "сум за {{months}} мес",
    receipt_per_month: "Цена в месяц со скидкой",
    receipt_save: "Экономия",
    show_detail: "Показать расчёт",
    hide_detail: "Скрыть расчёт",
    month_one: "месяц",
    month_few: "месяца",
    month_many: "месяцев",
    rules_title: "Как считается",
    rules: [
      "Цена — сумма компонентов. Тарифов нет.",
      "Минимальный срок покупки — 3 месяца.",
      "Скидка за срок: 3 месяца −10%, 6 месяцев −20%, 12 месяцев −30%.",
      "Итог округляется в меньшую сторону до 0,05 БРВ.",
      "Минимум: 1 филиал, 1 сотрудник, 1 POS-устройство.",
      "Своя доставка, приложение официанта, QR-меню и Yandex Eats — на каждый филиал, не больше числа филиалов.",
    ],
    notes_title: "Что оплачивается отдельно",
    notes: [
      "Онбординг и настройка — бесплатно, силами нашей команды.",
      "Оборудование (моноблок, принтер, экраны) покупается отдельно. Это разовая статья, суммы очень разные — поможем подобрать под ваш зал и бюджет.",
    ],
    cta: "Связаться",
    cta_note: "Первый месяц бесплатно, полный набор. Дальше — минимальный срок 3 месяца.",
  },
  faq: {
    tag: "Вопросы",
    title: "Частые вопросы",
    items: [
      {
        q: "Как считается цена?",
        a: "Тарифов нет. Вы собираете набор из девяти компонентов, и цена — их сумма. Цены привязаны к БРВ, минимальный срок покупки — 3 месяца, скидка за срок: 3 месяца −10%, 6 месяцев −20%, 12 месяцев −30%. Минимальный набор — 1 филиал, 1 сотрудник и 1 POS-устройство.",
      },
      {
        q: "Что входит в подписку без доплат?",
        a: "Кухня (KDS), приложение менеджера, лояльность и CRM, AI-аналитика, киоск самообслуживания, Open API, стоп-лист, смены и Z-отчёты, план зала, E-Kassa (ОФД), PIN на возвраты, push владельцу и печать чеков. Платить нужно только за филиалы, сотрудников, POS-устройства, свою доставку, приложение официанта, QR-меню, Yandex Eats, экраны и склады.",
      },
      {
        q: "Что такое БРВ и зачем цена в нём?",
        a: "БРВ — базовая расчётная величина, к которой в Узбекистане привязаны многие расчёты. Сейчас 1 БРВ = 412 000 сум. Цены в БРВ означают, что мы не переписываем прайс вручную: при изменении БРВ сумма в сумах пересчитывается автоматически. Платите вы в сумах.",
      },
      {
        q: "Правда ли, что склад считает ингредиенты, а не порции?",
        a: "Да. У каждого блюда есть технологическая карта. Когда вы продаёте плов, со склада списываются рис, масло и мясо в указанных количествах. Поэтому остаток настоящий, себестоимость считается сама, а стоп-лист формируется автоматически — как только кончился любой ингредиент.",
      },
      {
        q: "Как работает своя доставка?",
        a: "Вы получаете собственную витрину: Telegram Mini App, сайт и мобильное приложение, при желании на своём домене. Оплата — Click, Payme и Rahmat. Заказ попадает сразу в кассу и на кухню, на том же меню и тех же остатках. Комиссию агрегатора за такие заказы вы не платите. Yandex Eats при этом тоже можно подключить, если он вам нужен.",
      },
      {
        q: "Сколько занимает внедрение?",
        a: "До недели. Настройку делает наша команда: переносим меню, заводим технологические карты, подключаем оборудование и обучаем сотрудников. Онбординг бесплатный.",
      },
      {
        q: "Нужно ли покупать оборудование?",
        a: "Если у вас его ещё нет — да. Моноблок для кассы, чековый принтер, экраны для кухни и меню покупаются отдельно. Это разовая статья, и суммы очень разные, поэтому мы не включаем её в подписку. Подскажем, что именно нужно вашему залу, и подберём под бюджет. Samly работает на Android и iOS, так что часть можно закрыть обычным планшетом.",
      },
      {
        q: "Работает ли без интернета?",
        a: "Касса и кухонный экран работают офлайн. Экраны меню могут крутить контент с USB-накопителя. Когда интернет возвращается, данные синхронизируются сами — ни один заказ не теряется.",
      },
      {
        q: "Какие интеграции уже работают?",
        a: "Оплата — Click, Payme и Rahmat. Доставка — своя витрина и Yandex Eats. Фискализация — E-Kassa (ОФД). Оборудование — любые принтеры ESC/POS и StarPRNT. Uzum Pay и Uzum Tezkor мы планируем подключить.",
      },
      {
        q: "Что даёт бесплатный месяц?",
        a: "Полный набор компонентов на месяц, без карты и без обязательств. Если после этого остаётесь, дальше действует минимальный срок в 3 месяца.",
      },
      {
        q: "Есть ли поддержка на узбекском?",
        a: "Да. Интерфейс на узбекском, русском и английском. Поддержка отвечает на узбекском и русском по телефону и в Telegram — ежедневно, кроме воскресенья, с 10:00 до 22:00.",
      },
    ],
  },
  cta: {
    title: "Покажем Samly на вашем меню",
    subtitle: "Первый месяц бесплатно, полный набор · Настройку делает наша команда",
    note: "Онбординг бесплатный. Оборудование покупается отдельно — поможем подобрать.",
    cta_primary: "Связаться",
    cta_secondary: "Позвонить",
    trust_payment: "Click · Payme · Rahmat",
    trust_support: "Поддержка 6 дней в неделю",
    trust_local: "Сделано для Узбекистана",
  },
  footer: {
    description:
      "Одно меню и один склад на всё заведение: касса, своя доставка, QR-меню, официант, экраны и склад.",
    product: "Продукт",
    support: "Поддержка",
    contacts: "Контакты",
    copyright: "Все права защищены.",
    lang_label: "Язык",
    links: {
      features: "Возможности",
      pricing: "Цена",
      integrations: "Интеграции",
      modules: "Что входит",
      apps: "Приложения",
      faq: "Частые вопросы",
      contact: "Связаться",
      telegram: "Telegram",
    },
  },
  contact: {
    title: "Обсудим ваше заведение",
    subtitle: "Позвоните или напишите — покажем Samly и настроим вместе с вами.",
    call: "Позвонить",
    telegram_label: "Telegram",
    instagram_label: "Instagram",
    hours_label: "Часы работы",
    hours: "Пн–Сб, 10:00–22:00",
    trust: "Первый месяц бесплатно · Настройку делает наша команда",
  },
  modal: {
    title: "Попробуйте Samly бесплатно",
    subtitle: "Оставьте заявку — менеджер свяжется в рабочее время",
    name_placeholder: "Ваше имя",
    phone_placeholder: "Номер телефона",
    submit: "Отправить заявку",
    submitting: "Отправляем...",
    success_title: "Заявка принята!",
    success_desc: "Менеджер свяжется с вами в рабочее время",
    error_required: "Обязательное поле",
    error_name_min: "Минимум 2 символа",
    error_phone: "Введите корректный номер телефона",
    error_server: "Ошибка. Попробуйте ещё раз",
    toast_error_title: "Не удалось отправить",
  },
  apps: {
    title: "Наши приложения",
    subtitle: "Касса — на компьютер, приложения владельца и официанта — на телефон.",
    pos: {
      title: "Касса Samly для Windows",
      desc: "Программа для компьютера на кассе: заказы, оплата, печать чеков.",
      button: "Скачать для Windows",
      mobileHint: "Установите на компьютер кассы",
    },
    owner: { title: "Приложение владельца", desc: "Выручка, смены и отчёты по всем заведениям в телефоне." },
    waiter: { title: "Приложение официанта", desc: "Приём заказов у стола и отправка на кухню." },
    soon: "Скоро",
    downloadOn: "Загрузите в",
    getItOn: "Доступно в",
  },
  installGuide: {
    title: "Как установить кассу",
    subtitle: "Скачивание уже началось. Если Windows покажет предупреждение — это нормально, следуйте шагам ниже.",
    subtitleHash: "Скачайте установщик кнопкой ниже и следуйте шагам. Если Windows покажет предупреждение — это нормально.",
    steps: {
      browser: {
        title: "Сохраните файл",
        text: "Браузер может написать, что файл скачивают редко. Нажмите «Сохранить». В Edge: «…» → «Сохранить» → «Показать больше» → «Всё равно сохранить».",
      },
      smartscreen: {
        title: "Откройте установщик",
        text: "Запустите скачанный файл. Windows покажет окно «Windows защитила ваш компьютер». Нажмите «Подробнее».",
      },
      runAnyway: {
        title: "Разрешите запуск",
        text: "Появится кнопка «Выполнить в любом случае». Нажмите её. Окно появляется, потому что у установщика пока нет цифровой подписи.",
      },
      installer: {
        title: "Установите кассу",
        text: "Windows спросит, разрешить ли приложению вносить изменения, — нажмите «Да». Пройдите шаги мастера установки до конца. На рабочем столе появится ярлык Samly POS.",
      },
      connect: {
        title: "Подключите кассу",
        text: "Откройте Samly POS и введите код подключения. Код есть в бэк-офисе: Настройки филиала → Устройства.",
      },
    },
    retry: "Скачивание не началось?",
    retryLink: "Скачать ещё раз",
    help: "Не получается установить? Напишите нам в Telegram",
    close: "Понятно",
  },
};
